import React, { Component } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Button, Message } from 'semantic-ui-react'
import Api from '~/api'
import { connectForm, ModalForm, Group, Form, Field, Submit, InfoGroup, Info } from '~/form'
import { updateArticle } from '../actions'
import moment from 'moment'
import ArticleForm, { ArticleFormValidations } from './form'
import { fetchTaskTypes } from '~/taskType/actions'

class ArticleCreate extends Component {
  static formSubmit(dispatch, formId, values, changed, { onSubmit }) {
    dispatch(updateArticle(formId, values.get('id'), values.toJS(), onSubmit))
  }

  static formValidation = ArticleFormValidations

  state = {
    loading: true,
    error: false,
  }

  componentDidMount = () => {
    let { articleId, formInit } = this.props
    let { formSetMeta, onSubmit } = this.props

    if (onSubmit) formSetMeta({ onSubmit })

    Api.get(`/article/${articleId}`)
      .then(({ data }) => {
        let stateUpdate = {
          loading: false,
        }

        if (data.success) formInit(data.item)
        else stateUpdate.error = error

        this.setState(stateUpdate)
      })
      .catch(err => {
        console.log(err)
        this.setState({
          loading: false,
          error: true,
        })
      })
  }

  render() {
    let { formUpdate, formSubmit, formState, formLoading, onClose } = this.props
    let { loading, error } = this.state

    let actions = (
      <Button
        size="tiny"
        color="green"
        content="Päivitä artikkeli"
        onClick={e => e.preventDefault() & formSubmit()}
        icon="save"
      />
    )

    if (loading) formState = Object.assign({}, formState, { loading })

    return (
      <ModalForm id="article-form" onSubmit={formSubmit} formState={formState} actions={actions} onClose={onClose}>
        {error ? (
          <Message error content="Something went wrong." />
        ) : (
          <ArticleForm {...this.props} title="Päivitä artikkeli" key="article-create" submit="Päivitä artikkeli" />
        )}
      </ModalForm>
    )
  }
}

function mapStateToProps(state) {
  return {}
}

function mapDispatchToProps(dispatch) {
  return {}
}

export default connectForm('article-create', ArticleCreate, mapStateToProps, mapDispatchToProps)
